import React from 'react';
import { routes } from 'utils/routes';
import { Link } from 'react-router-dom';
import { Typography } from '@eucalyptusvc/design-system';

export default function Error(): React.ReactElement {
  return (
    <section className="max-w-2xl py-10 md:py-12 px-4 mx-auto space-y-4 text-center">
      <Typography size="lg" isBold>
        Page not found
      </Typography>
      <Typography size="landing-paragraph">
        <Link className="text-link" to={routes.profile}>
          Go to your Profile
        </Link>
      </Typography>
    </section>
  );
}
